import { lazy, Suspense } from 'react'
import { To } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import { useFeatures } from 'modules/core/hooks/useFeatures'

import { Folder } from 'modules/documents/hooks/useGetFolders'
import { SPACE } from 'modules/documents/lib/constants'

const LegacyDataTable = lazy(() => import('./LegacyDataTable'))
const CompanyDocumentsDataCollection = lazy(() => import('./DataCollection'))

const LoadingFallback = () => (
  <Box alignItems="center" padding="s64">
    <Spinner />
  </Box>
)

type Props = {
  onNavigationClick: (documentId: string) => void
  onDrop: (files: File[]) => void
  folder?: Folder | null
  initialFolder?: Folder | null
  parentRoute?: To
  multiple?: boolean
  readonly: boolean
  space: SPACE
  onUpload?: () => void
}

const CompanyDocumentsDataTable = (props: Props) => {
  const { has_dev_documents_data_collection } = useFeatures(['dev_documents_data_collection'])

  return (
    <Suspense fallback={<LoadingFallback />}>
      {has_dev_documents_data_collection ? (
        <CompanyDocumentsDataCollection
          onDrop={props.onDrop}
          folder={props.folder}
          initialFolder={props.initialFolder}
          parentRoute={props.parentRoute}
          multiple={props.multiple}
          readonly={props.readonly}
          space={props.space}
          onUpload={props.onUpload}
        />
      ) : (
        <LegacyDataTable {...props} />
      )}
    </Suspense>
  )
}

export default CompanyDocumentsDataTable
